import {
    useEffect,
    useState,
    useMemo,
    useRef
} from 'react';
import {
    Container,
    Filters,
    Content,
    Box1,
    Box2,
    Line,
    Footer,
    OptionFilter,
    ActionDown,
    ButtonSearch,
    Load,
} from './styled';
import {
    BiChevronDown,
    BiChevronUp
} from 'react-icons/bi';
import {
    BiSearchAlt
} from 'react-icons/bi';
import { PiBroomBold } from 'react-icons/pi';
import {
    DatePicker,
    Contacts,
    UsersSystem
} from '../../../../../../components';
import { Card } from './components/Card';
import { useChat } from '../../../../../../contexts/chat';
import { useNotification } from '../../../../../../contexts/notification';
import { getCloseCustomer } from '../../../../../../service/serviceChat/customerService';
import { FaAngleLeft } from "react-icons/fa";
import { FaAngleRight } from "react-icons/fa";

import moment from 'moment';

export function Close(props) {
    const { isVisibility } = props;
    const {
        customer,
        idUser,
        accessLevel,
        setMyChatsClose,
        myChatsClose,
        onFilter
    } = useChat();
    const { handlerMyChatsClose } = useNotification();

    const [dataCustomer, setDataCustomer] = useState({});
    const [filterIsHidden, setFilterIsHidden] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);
    const [filterContact, setFilterContact] = useState(
        { id: 0, name: '' }
    );
    const [filterUser, setFilterUser] = useState(
        { id: 0, nomecompleto: '' }
    );
    const [hideListContact, setHideListContact] = useState(false);
    const [hideListUser, setHideListUser] = useState(false);
    const [displayedPeople, setDisplayedPeople] = useState(50);
    const listRef = useRef(null);
    const numberRef = useRef(null);

    const [dateStartFilterCloseCustomer, setDateStartFilterCloseCustomer] = useState(
        moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const [dateEndFilterCloseCustomer, setDateEndFilterCloseCustomer] = useState(
        moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));


    useEffect(() => {
        if (typeof customer !== 'string') return setDataCustomer(customer);
        return setDataCustomer(JSON.parse(customer));
    }, [customer]);

    const searchCustomerClose = async () => {
        setIsLoading(true)
        setMyChatsClose([]);
        let usuario_id = filterUser.id;
        if (!accessLevel?.includes('TODOS_FECHADOS')) usuario_id = idUser;
        const customers = await getCloseCustomer(
            id,
            filterContact.id,
            usuario_id,
            moment(dateStartFilterCloseCustomer).format('DD/MM/YYYY'),
            moment(dateEndFilterCloseCustomer).format('DD/MM/YYYY')
        );
        handlerMyChatsClose(customers?.length);
        setMyChatsClose([...customers]);
        setIsLoading(false)
    };
    useEffect(() => {
        if (myChatsClose?.length > 0) return
        searchCustomerClose()
    }, []);

    const handleScroll = () => {
        const element = listRef.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        };
    };
    useEffect(() => {
        const element = listRef.current;
        element.addEventListener('scroll', handleScroll);
        return () => element?.removeEventListener('scroll', handleScroll);
    }, []);
    const visibleData = myChatsClose
        .filter(
            (e) => {
                return onFilter(e, 3)
            }
        )
        ?.slice(0, displayedPeople);


    const myStateElements = useMemo(() => visibleData?.map((item, key) => (
        <Card
            key={item.id}
            data={item}
            active={dataCustomer && dataCustomer.id === visibleData[key].id}
            load={() => searchCustomerClose()}
        />
    )), [visibleData]);

    const handleClearFilters = () => {
        setFilterContact(
            { id: 0, name: '' }
        );
        setFilterUser(
            { id: 0, nomecompleto: '' }
        );
        setId(0);
        numberRef.current.value = '';
    };
    
    return (
        <Container visibility={isVisibility ? 1 : 0}>
            <Filters className={`${isLoading && 'isLoading'}`}>
                <Box1>
                    <Line>
                        <DatePicker
                            className="date"
                            value={dateStartFilterCloseCustomer}
                            onChange={setDateStartFilterCloseCustomer}
                        />
                        -
                        <DatePicker
                            className="date"
                            value={dateEndFilterCloseCustomer}
                            onChange={setDateEndFilterCloseCustomer}
                        />
                        <ButtonSearch
                            onClick={() => searchCustomerClose()}
                            className={`${isLoading && 'isLoading'}`}
                        >
                            {isLoading
                                ? <Load />
                                : <BiSearchAlt />
                            }
                        </ButtonSearch>
                        <ActionDown
                            className={`${!filterIsHidden && 'effect'}`}
                            onClick={() => setFilterIsHidden(!filterIsHidden)}>
                            {(!filterIsHidden)
                                ? <FaAngleLeft />
                                : <FaAngleRight />
                            }
                        </ActionDown>
                    </Line>
                </Box1>
                {!filterIsHidden &&
                    <Box2>
                        <OptionFilter>
                            <div className='xlss-b'>
                                <div className='xlss-l'
                                    onClick={() => {
                                        setHideListUser(false)
                                        setHideListContact(!hideListContact)
                                    }}
                                >
                                    <div className='selected--'>
                                        {`Contato: ${filterContact?.name}`}
                                    </div>
                                    {!hideListContact
                                        ? <BiChevronDown fontSize={'20px'} />
                                        : <BiChevronUp fontSize={'20px'} />
                                    }
                                </div>
                                <div className={`xlss-a ${!hideListContact && 'hidden--'}`}>
                                    <Contacts
                                        onChange={(contato) => {
                                            setFilterContact(contato)
                                            setHideListContact(!hideListContact)
                                        }}
                                    />
                                </div>
                            </div>
                        </OptionFilter>
                        {accessLevel?.includes('TODOS_FECHADOS') &&
                            <OptionFilter>
                                <div className='xlss-b'>
                                    <div className='xlss-l'
                                        onClick={() => {
                                            setHideListContact(false)
                                            setHideListUser(!hideListUser)
                                        }}
                                    >
                                        <div className='selected--'>
                                            {`Usuario/Setor: ${filterUser?.nomecompleto}`}
                                        </div>
                                        {!hideListUser
                                            ? <BiChevronDown fontSize={'20px'} />
                                            : <BiChevronUp fontSize={'20px'} />
                                        }
                                    </div>
                                    <div className={`xlss-a ${!hideListUser && 'hidden--'}`}>
                                        <UsersSystem
                                            onChange={(contato) => {
                                                setFilterUser(contato)
                                                setHideListUser(!hideListUser)
                                            }}
                                        />
                                    </div>
                                </div>
                            </OptionFilter>
                        }
                        <Footer>
                            <input
                                ref={numberRef}
                                type="number"
                                min={1}
                                onChange={(e) => setId(e.target.value)}
                                placeholder='N.º do Atendimento'
                            />
                            <div className='actions--'>
                                <span
                                    onClick={() => searchCustomerClose()}
                                    className={`apply ${isLoading && 'isLoading'}`}
                                >
                                    Aplicar
                                </span>
                                <span
                                    className='clear'
                                    title='limpar'
                                    onClick={() => handleClearFilters()}>
                                    <PiBroomBold fontSize={'20px'} />
                                </span>
                            </div>
                        </Footer>
                    </Box2>
                }
            </Filters>
            <Content ref={listRef}>
                {myChatsClose?.length !== 0 && <>{myStateElements}</>}
            </Content>
        </Container>
    );
}   